<wa-card>
  <div class="wa-cluster wa-gap-xs" slot="header">
    <h3>{{ survey().name }}</h3>
    @if (voting_ongoing) {
      <wa-badge appearance="filled outlined" pill variant="success">
        <wa-icon label="open" name="hand-point-right"></wa-icon>
        open now!
      </wa-badge>
    } @else if (voting_ended) {
      <wa-badge appearance="filled outlined" pill variant="danger">
        <wa-icon label="deadline passed" name="octagon"></wa-icon>
        deadline passed
      </wa-badge>
    } @else {
      <wa-badge appearance="filled outlined" pill variant="warning">
        <wa-icon label="coming up" name="hand-point-up"></wa-icon>
        coming up
      </wa-badge>
    }
    @if (survey().published) {
      <wa-badge appearance="filled outlined" pill variant="brand">
        <wa-icon label="published" name="megaphone"></wa-icon>
        results published
      </wa-badge>
    }
  </div>
  <div class="wa-flank">
    <div class="wa-stack">
      <wa-card appearance="plain">
        <div class="wa-flank wa-align-items-start">
          <wa-avatar shape="rounded">
            <wa-icon name="calendar" slot="icon"></wa-icon>
          </wa-avatar>
          <div class="wa-stack wa-gap-2xs">
            <h3 class="wa-caption-s">Submit Excluded Time Periods</h3>
            <span class="wa-heading-l">{{ survey().begin | date: dateFormat }}
              - {{ survey().end | date: dateFormat }}</span>
          </div>
        </div>
      </wa-card>
      <wa-card appearance="plain">
        <div class="wa-flank wa-align-items-start">
          <wa-avatar shape="rounded">
            <wa-icon name="file-contract" slot="icon"></wa-icon>
          </wa-avatar>
          <div class="wa-stack wa-gap-2xs">
            <div class="wa-cluster wa-gap-xs">
              <h3 class="wa-caption-s">Exam Dates</h3>
              <wa-badge appearance="filled outlined" pill variant="warning">
                <wa-icon label="preliminary" name="exclamation"></wa-icon>
                preliminary dates
              </wa-badge>
            </div>
            <span class="wa-heading-l">{{ survey().exams_from | date: dateFormat }}
              - {{ survey().exams_until | date: dateFormat }}</span>
          </div>
        </div>
      </wa-card>
    </div>
    <div class="wa-stack wa-gap-xl wa-align-items-stretch">
      <div>
        @if (voting_ongoing) {
          <wa-button (click)="submitExclusionsEvent.emit(survey())" appearance="filled" variant="success">
            <wa-icon name="calendar" slot="end"></wa-icon>
            submit excluded times
          </wa-button>
        } @else {
          <wa-button (click)="submitExclusionsEvent.emit(survey())" appearance="filled" variant="neutral">
            <wa-icon name="calendar" slot="end"></wa-icon>
            show excluded times and results
          </wa-button>
        }
      </div>
      @if (showAdminControls()) {
        <div class="wa-cluster wa-gap-xs">
          <wa-button (click)="editAssignmentsEvent.emit(survey())" appearance="filled" variant="brand">
            <wa-icon label="edit assignments" name="users" slot="end"></wa-icon>
            assignments
          </wa-button>
          <wa-button (click)="optimizationDashboardEvent.emit(survey())" appearance="filled" variant="brand">
            <wa-icon label="dashboard" name="gauge" slot="end"></wa-icon>
            optimization
          </wa-button>
        </div>
        <div class="wa-cluster wa-gap-xs">
          <wa-button (click)="editSurveyEvent.emit(survey())" appearance="filled" variant="brand">
            <wa-icon label="edit survey" name="pen" slot="end"></wa-icon>
            edit
          </wa-button>
          <wa-button (click)="publishSurveyEvent.emit(survey())" [disabled]="survey().published" appearance="filled"
                     variant="brand">
            <wa-icon label="publish" name="megaphone" slot="end"></wa-icon>
            publish
          </wa-button>
          <wa-button (click)="removeSurveyEvent.emit(survey())" appearance="filled" variant="danger">
            <wa-icon label="remove survey" name="trash" slot="end"></wa-icon>
            remove
          </wa-button>
        </div>
      }
    </div>
  </div>
</wa-card>
